export default function DeviceLinkingSkeleton() {
  return (
    <div className="w-full max-w-2xl mx-auto p-4 sm:p-6 bg-white border border-gray-200 rounded-xl sm:rounded-2xl shadow-sm">
      <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
        <div className="w-5 h-5 sm:w-6 sm:h-6 bg-gray-200 rounded animate-pulse" />
        <div className="h-6 sm:h-8 w-32 sm:w-40 bg-gray-200 rounded animate-pulse" />
      </div>

      <div className="mb-4 sm:mb-6">
        <div className="h-4 sm:h-5 w-full bg-gray-200 rounded animate-pulse mb-2" />
        <div className="h-4 sm:h-5 w-3/4 bg-gray-200 rounded animate-pulse" />
      </div>

      {/* Generate Link Code Section Skeleton */}
      <div className="mb-4 sm:mb-6 p-3 sm:p-4 bg-gray-50 rounded-lg">
        <div className="h-5 sm:h-6 w-32 sm:w-40 bg-gray-200 rounded animate-pulse mb-2 sm:mb-3" />
        <div className="h-3 sm:h-4 w-full bg-gray-200 rounded animate-pulse mb-3 sm:mb-4" />
        <div className="h-10 sm:h-12 w-full bg-gray-200 rounded animate-pulse" />
      </div>

      {/* Enter Link Code Section Skeleton */}
      <div className="mb-4 sm:mb-6 p-3 sm:p-4 bg-gray-50 rounded-lg">
        <div className="h-5 sm:h-6 w-28 sm:w-36 bg-gray-200 rounded animate-pulse mb-2 sm:mb-3" />
        <div className="h-3 sm:h-4 w-full bg-gray-200 rounded animate-pulse mb-3 sm:mb-4" />
        <div className="flex flex-col sm:flex-row gap-2">
          <div className="flex-1 h-10 sm:h-12 bg-gray-200 rounded animate-pulse" />
          <div className="w-full sm:w-32 h-10 sm:h-12 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>
    </div>
  );
}

